import req from './req'

// 群发消息管理-获取群发消息
export function getGroupmsgList (params) {
  return req.get('/groupmsg/list', params)
}

// 群发消息管理-删除群发消息
export function deleteGroupMsg (msgId, params) {
  return req.post('/groupmsg/delete/' + msgId, params)
}

// 群发消息管理-创建群发消息
export function createGroupMsg (params) {
  return req.post('/groupmsg/create', params)
}

// 群发消息管理-根据msgId获取群发消息
export function getGroupmsgInfo (msgId, params) {
  return req.get('/groupmsg/info/' + msgId, params)
}

// 群发消息管理-修改群发消息
export function updateGroupMsg (msgId, params) {
  return req.post('/groupmsg/update/' + msgId, params)
}

// 群发消息管理-模版消息发送大概人数
export function sendCount (params) {
  return req.post('/groupmsg/send-count', params)
}

// 群发消息管理-群发消息统计
export function getGroupmsgStatistic (msgId, params) {
  return req.get('/groupmsg/statistic/' + msgId, params)
}

// 群发消息管理-发送员工统计信息
export function getStatisticSendSalesperson (msgId, params) {
  return req.get('/groupmsg/statistic-send-salesperson/' + msgId, params)
}

// 群发消息管理-发送客户统计信息
export function getStatisticSendMember (msgId, params) {
  return req.get('/groupmsg/statistic-send-member/' + msgId, params)
}
